import React from "react";
import { Card, CardBody, CardHeader, CardTitle, Container, Row, Col } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";

const ContactPage = () => {
  const t = useTranslation();

  return (
    <div className="content">
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h2">
                  {t("client.contact") || "Contact Us"}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <p>
                  {t("client.contactDescription") || 
                    "Get in touch with us for any inquiries or support."}
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactPage;

